// 手机购物
import onlineShoppingIndex from '@/views/shopping/onlineShopping/index'

const dyRoutes = Array.from({ length: 12 }, (_, i) => ({
  path: `onlineShopping/dy/index${i + 1}`,
  name: `onlineShopping/dy/Index${i + 1}`,
  component: () => import(`@/views/shopping/onlineShopping/dy/index${i + 1}.vue`)
}))
const branch1dyRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `onlineShopping/dy/branch1/index${i + 1}`,
  name: `onlineShopping/dy/branch1/Index${i + 1}`,
  component: () => import(`@/views/shopping/onlineShopping/dy/branch1/index${i + 1}.vue`)
}))
const branch2dyRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `onlineShopping/dy/branch2/index${i + 1}`,
  name: `onlineShopping/dy/branch2/Index${i + 1}`,
  component: () => import(`@/views/shopping/onlineShopping/dy/branch2/index${i + 1}.vue`)
}))
const branch3dyRoutes = Array.from({ length: 3 }, (_, i) => ({
  path: `onlineShopping/dy/branch3/index${i + 1}`,
  name: `onlineShopping/dy/branch3/Index${i + 1}`,
  component: () => import(`@/views/shopping/onlineShopping/dy/branch3/index${i + 1}.vue`)
}))

const jdRoutes = Array.from({ length: 14 }, (_, i) => ({
  path: `onlineShopping/jd/index${i + 1}`,
  name: `onlineShopping/jd/Index${i + 1}`,
  component: () => import(`@/views/shopping/onlineShopping/jd/index${i + 1}.vue`)
}))
const branch1jdRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `onlineShopping/jd/branch1/index${i + 1}`,
  name: `onlineShopping/jd/branch1/Index${i + 1}`,
  component: () => import(`@/views/shopping/onlineShopping/jd/branch1/index${i + 1}.vue`)
}))
const branch2jdRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `onlineShopping/jd/branch2/index${i + 1}`,
  name: `onlineShopping/jd/branch2/Index${i + 1}`,
  component: () => import(`@/views/shopping/onlineShopping/jd/branch2/index${i + 1}.vue`)
}))
const branch3jdRoutes = Array.from({ length: 5 }, (_, i) => ({
  path: `onlineShopping/jd/branch3/index${i + 1}`,
  name: `onlineShopping/jd/branch3/Index${i + 1}`,
  component: () => import(`@/views/shopping/onlineShopping/jd/branch3/index${i + 1}.vue`)
}))

const pddRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `onlineShopping/pdd/index${i + 1}`,
  name: `onlineShopping/pdd/Index${i + 1}`,
  component: () => import(`@/views/shopping/onlineShopping/pdd/index${i + 1}.vue`)
}))
const branch1pddRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `onlineShopping/pdd/branch1/index${i + 1}`,
  name: `onlineShopping/pdd/branch1/Index${i + 1}`,
  component: () => import(`@/views/shopping/onlineShopping/pdd/branch1/index${i + 1}.vue`)
}))
const branch2pddRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `onlineShopping/pdd/branch2/index${i + 1}`,
  name: `onlineShopping/pdd/branch2/Index${i + 1}`,
  component: () => import(`@/views/shopping/onlineShopping/pdd/branch2/index${i + 1}.vue`)
}))
const branch3pddRoutes = Array.from({ length: 4 }, (_, i) => ({
  path: `onlineShopping/pdd/branch3/index${i + 1}`,
  name: `onlineShopping/pdd/branch3/Index${i + 1}`,
  component: () => import(`@/views/shopping/onlineShopping/pdd/branch3/index${i + 1}.vue`)
}))

const tbRoutes = Array.from({ length: 15 }, (_, i) => ({
  path: `onlineShopping/tb/index${i + 1}`,
  name: `onlineShopping/tb/Index${i + 1}`,
  component: () => import(`@/views/shopping/onlineShopping/tb/index${i + 1}.vue`)
}))
const branch1tbRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `onlineShopping/tb/branch1/index${i + 1}`,
  name: `onlineShopping/tb/branch1/Index${i + 1}`,
  component: () => import(`@/views/shopping/onlineShopping/tb/branch1/index${i + 1}.vue`)
}))
const branch2tbRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `onlineShopping/tb/branch2/index${i + 1}`,
  name: `onlineShopping/tb/branch2/Index${i + 1}`,
  component: () => import(`@/views/shopping/onlineShopping/tb/branch2/index${i + 1}.vue`)
}))
const branch3tbRoutes = Array.from({ length: 4 }, (_, i) => ({
  path: `onlineShopping/tb/branch3/index${i + 1}`,
  name: `onlineShopping/tb/branch3/Index${i + 1}`,
  component: () => import(`@/views/shopping/onlineShopping/tb/branch3/index${i + 1}.vue`)
}))

export default {
  path: '/shopping',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'onlineShopping/index',
      name: 'onlineShoppingIndex',
      component: onlineShoppingIndex
    },
    // 手机购物，开始
    ...dyRoutes,
    ...branch1dyRoutes,
    ...branch2dyRoutes,
    ...branch3dyRoutes,
    ...jdRoutes,
    ...branch1jdRoutes,
    ...branch2jdRoutes,
    ...branch3jdRoutes,
    ...pddRoutes,
    ...branch1pddRoutes,
    ...branch2pddRoutes,
    ...branch3pddRoutes,
    ...tbRoutes,
    ...branch1tbRoutes,
    ...branch2tbRoutes,
    ...branch3tbRoutes

  ]
}
